import { postFormData } from 'application/adapters/cms/formAdapter';

export const postFormWithId = async (formId, body) => {
	return await postFormData(formId, body);
};
